import { IsUUID } from 'class-validator';

export class WsDeviceSessionAuthenticateDto {
  @IsUUID()
  deviceSessionId: string;
}

export class WsDeviceSessionRejectDto extends WsDeviceSessionAuthenticateDto {}
